/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ExecuteGipReportMutationRequest, ExecuteGipReportMutationResponse, ExecuteGipReportQueryParams, ExecuteGipReport400, ExecuteGipReport500 } from "../models/ExecuteGipReport";

export function getExecuteGipReportUrl() {
  const res = { method: 'POST', url: `/reports/gip/results` as const }
  return res
}

/**
 * @summary Generate report results
 * {@link /reports/gip/results}
 */
export async function executeGipReport(data: ExecuteGipReportMutationRequest, params?: ExecuteGipReportQueryParams, config: Partial<RequestConfig<ExecuteGipReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ExecuteGipReportMutationResponse, ResponseErrorConfig<ExecuteGipReport400 | ExecuteGipReport500>, ExecuteGipReportMutationRequest>({ method : "POST", url : getExecuteGipReportUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}